var map = {
	"./01_CALCINHA_LATERAL_DRAPEADA_LISA_02.jpg": 372,
	"./02_CALCINHA_LATERAL_DRAPEADA_LISA_02.jpg": 373,
	"./02_CALCINHA_LATERAL_DRAPEADA_LISA_04.jpg": 374,
	"./02_CALCINHA_LATERAL_DRAPEADA_LISA_06.jpg": 375,
	"./02_CALCINHA_LATERAL_DRAPEADA_LISA_08.jpg": 376,
	"./02_CALCINHA_LATERAL_DRAPEADA_LISA_10.jpg": 377,
	"./03_CALCINHA_ASA_DELTA_02.jpg": 378,
	"./03_CALCINHA_ASA_DELTA_04.jpg": 379,
	"./03_CALCINHA_ASA_DELTA_06.jpg": 380,
	"./03_CALCINHA_ASA_DELTA_08.jpg": 381,
	"./03_CALCINHA_ASA_DELTA_10.jpg": 382,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.jpg": 383,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_04.jpg": 384,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_06.jpg": 385,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_08.jpg": 386,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_10.jpg": 387,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_12.jpg": 388,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_14.jpg": 389,
	"./04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_16.jpg": 390,
	"./05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_02.jpg": 391,
	"./05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_04.jpg": 392,
	"./05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_06.jpg": 393,
	"./05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_08.jpg": 394,
	"./05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_10.jpg": 395,
	"./06_CALCINHA_FIO_DUPLO_LISA_02.jpg": 396,
	"./06_CALCINHA_FIO_DUPLO_LISA_04.jpg": 397,
	"./06_CALCINHA_FIO_DUPLO_LISA_06.jpg": 398,
	"./06_CALCINHA_FIO_DUPLO_LISA_08.jpg": 399,
	"./06_CALCINHA_FIO_DUPLO_LISA_10.jpg": 400,
	"./07_CALCINHA_DE_AMARRAR_LISA_02.jpg": 401,
	"./07_CALCINHA_DE_AMARRAR_LISA_04.jpg": 402,
	"./07_CALCINHA_DE_AMARRAR_LISA_06.jpg": 403,
	"./08_CALCINHA_ASA_DELTA_ESTAMPADA_02.jpg": 404,
	"./08_CALCINHA_ASA_DELTA_ESTAMPADA_04.jpg": 405,
	"./09_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_02.jpg": 406,
	"./09_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_04.jpg": 407,
	"./09_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_06.jpg": 408,
	"./10_CALCINHA_DRAPEADA_LARGA_LISA_02.jpg": 409,
	"./10_CALCINHA_DRAPEADA_LARGA_LISA_04.jpg": 410,
	"./17_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.jpg": 411,
	"./17_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_04.jpg": 412,
	"./18_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.jpg": 413,
	"./18_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_04.jpg": 414,
	"./19__CALCINHA_DRAPEADA_LISA_02.jpg": 415,
	"./20_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_02.jpg": 416,
	"./21_CALCINHA_DRAPEADA_LARGA_ESTAMPADA_02.jpg": 417,
	"./22_CALCINHA_TRADICIONAL_FINA_02.jpg": 418,
	"./23_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.jpg": 419,
	"./24_CALCINHA_FIO_DUPLO_ESTAMPADO_02.jpg": 420,
	"./24_CALCINHA_FIO_DUPLO_ESTAMPADO_04.jpg": 421,
	"./25_CALCINHA_FIO_DUPLO_LISA_02.jpg": 422,
	"./26_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_ESTAMPADO_02.jpg": 423,
	"./27_BEACHWEAR______CALCINHA_DE_AMARRAR_ESTAMPADA_02.jpg": 424,
	"./28_CALCINHA_TRADICIONAL_ESTAMPADA_02.jpg": 425,
	"./29_CALCINHA_BICOLOR_ALCA_REGULAVEL_02.jpg": 426,
	"./30_CALCINHA_FIO_DUPLO_ESTAMPADA_02.jpg": 427,
	"./31_CALCINHA_FIO_DUPLO_LISA_02.jpg": 428,
	"./32_CALCINHA_COM_BABADO_LISA_DE_AMARRAR_FINA_EMPINA_BUMBUM_02.jpg": 429,
	"./33_CALCINHA_LATERAL_DRAPEADA_LISA_02.jpg": 430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;